import React from 'react';

const TrustPilotStar = ({ className = '', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="23"
      viewBox="0 0 25 23"
      fill="none"
      className={className}
      {...props}
    >
      <g clipPath="url(#trustpilot-star-clip)">
        <path
          d="M24.0408 8.74006H14.8614L12.026 0L9.18186 8.74006L0.00244141 8.73135L7.43644 14.1383L4.592 22.8697L12.026 17.4714L19.451 22.8697L16.6156 14.1383L24.0408 8.74006Z"
          fill="#00B67A"
        />
        <path
          d="M17.2534 16.1151L16.6154 14.1383L12.0259 17.4714L17.2534 16.1151Z"
          fill="#005128"
        />
      </g>
      <defs>
        <clipPath id="trustpilot-star-clip">
          <rect width="24.043" height="22.8697" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrustPilotStar;

